import loadable from '@loadable/component';

export const PaymentSummaryContainerLoadable = loadable(
  () => import('./PaymentSummaryContainer'),
  { resolveComponent: (module) => module.PaymentSummaryContainer, ssr: false },
);
